module.exports = __webpack_public_path__ + "img/middle_opening.dae35721.svg";